let apiUrl =
  process.env.REACT_APP_API || "https://endpoint.charlessmithassociates.com/";
if (
  window.location.href.includes("jcsoftwaresolution") ||
  window.location.href.includes("localhost")
) {
  apiUrl = "https://iknowapi.jcsoftwaresolution.in/";
  // apiUrl = "https://endpoint.charlessmithassociates.com/";
}
const environment = {
  api: apiUrl,
  chatbot_api: apiUrl,
  user_role_id: "6996bdbee63505b3e36d1567",
};

export default environment;
